import { render, staticRenderFns } from "./ParticipateBox.vue?vue&type=template&id=5aa04314&scoped=true"
import script from "./ParticipateBox.vue?vue&type=script&lang=js"
export * from "./ParticipateBox.vue?vue&type=script&lang=js"
import style0 from "./ParticipateBox.vue?vue&type=style&index=0&id=5aa04314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa04314",
  null
  
)

export default component.exports